import React from 'react';

import styles from './KeyboardHint.module.css';

export interface KeyboardHintProps {
  keyName: string;
  testId?: string;
}

export function KeyboardHint({ keyName, testId }: KeyboardHintProps): React.ReactElement {
  return (
    <kbd className={styles.hint} data-testid={testId} aria-hidden="true">
      {keyName}
    </kbd>
  );
}

export default KeyboardHint;
